import React, {
  createContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { usersManagementServices } from "../APIServices/usersManagementServices";

export const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [currentUserData, setCurrentUserData] = useState(null);
  const [currentUserLoader, setCurrentUserLoader] = useState(false);

  const auth = localStorage.getItem("token");

  const getCurrentUserDetails = useCallback(async () => {
    if (!auth) {
      setCurrentUserData(null);
      return;
    }

    try {
      setCurrentUserLoader(true);

      const response =
        await usersManagementServices.getCurrentUserDetails();

      setCurrentUserData(response?.data || null);
    } catch (error) {
      console.error(error);
      setCurrentUserData(null);
    } finally {
      setCurrentUserLoader(false);
    }
  }, [auth]);

  useEffect(() => {
    getCurrentUserDetails();
  }, [getCurrentUserDetails]);

  const value = useMemo(
    () => ({
      currentUserData,
      currentUserLoader,
      getCurrentUserDetails,
    }),
    [
      currentUserData,
      currentUserLoader,
      getCurrentUserDetails,
    ]
  );

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}